module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_long_red.153f6864.png";